import React from "react";
import { fmtDate } from "./adminShared";

export function SubscribersTab({ subscribers }) {
  if (subscribers.length === 0) {
    return <p className="text-[#8f8571] text-sm py-10 text-center">No subscribers yet.</p>;
  }
  return (
    <div className="bg-white border border-[#eee6d6] divide-y divide-[#f2ecdd]" data-testid="admin-subscribers-list">
      {subscribers.map((s) => (
        <div key={s.id} className="flex items-center justify-between px-5 py-3">
          <p className="text-sm text-[#3a352c]">{s.email}</p>
          <span className="text-xs text-[#9c9482]">{fmtDate(s.createdAt)}</span>
        </div>
      ))}
    </div>
  );
}
